import React from 'react';
import { useI18n } from '@whizz/react-i18n';
import { useIdentity } from '@whizz/react-identity';
import { FeedbackFish } from '@feedback-fish/react';
import styled from 'styled-components';
import { Button } from '../../../components';

const ButtonStyled = styled(Button)`
  position: fixed;
  bottom: 20px;
  right: 20px;
`;

const Feedback = (): JSX.Element => {
  const { translate, locale } = useI18n();
  const { me } = useIdentity();

  if (process.env.REACT_APP_FEEDBACK_FISH_ID && locale && me) {
    return (
      <FeedbackFish projectId={process.env.REACT_APP_FEEDBACK_FISH_ID} userId={me.username} >
        <ButtonStyled isOutline color={'feedback'} id={'feedback-button'}>{translate('global.FEEDBACK')}</ButtonStyled>
      </FeedbackFish>
    );
  } else {
    return <></>;
  }
};

Feedback.displayName = 'Feedback';

export default Feedback;
